// extracted by mini-css-extract-plugin
export var card = "_74-0";
export var contentColor = "_74-2";
export var contentColorSecondary = "_74-3";
export var headerColor = "_74-1";